module.exports = __webpack_public_path__ + "img/dashboard_active.d8478b8a.svg";